import React from 'react';

const AboutMe = () => {
    return (
        <div className='h-screen'>
                <h2 className='text-3xl text-center text-orange-400 my-16'>About Me</h2>
        </div>
    );
};

export default AboutMe;